import mapJson from '@/tool/chinaMap_new.json'
import { isNull } from 'util';
//console.log(mapJson)
const filter = {
    formatDate: (date, fmt,isEndTime) => {
        if(!date) return '';
        if(isNaN(date)) date = date.replace(new RegExp(/-/gm),'/');//ie
        var val = moment(new Date(date)).format(fmt);
        if( isEndTime && val == '00:00' ) val = '24:00';
        return val;
    },
    gender: (val) => {
        if (val == 1) {
            return '男'
        } else {
            return '女';
        }
    },
    join: (val) =>{
        if (!val) {
            return '';
        }
        return val.join(',');
    },
    arr: (val,key) => {
        if (!val) {
            return;
        }
        let res = [];
        val.forEach(function (element) {
            if(!key) {
                res.push(element.value);
            }else{
                res.push(element[key]);
            }
        }, this);
        res = res.join('，');
        return res;
    },
    arrEx:(val)=>{
        if (!val) {
            return;
        }
        let res = [],
            teethlabel=['a','b','c','d','e','f','g','h','i'];
        val.forEach(function (element,index) {
            if( element != undefined && element!=null) {
                if(val.length==1){
                    res.push(element[0]+'('+element[1]+')');
                }else{
                    res.push(teethlabel[index]+"-"+element[0]+'('+element[1]+')');
                }

            }
        }, this);
        res = res.join('，');
        return res;
    },
    value: (val) => {
        if (!val || !val.value) {
            return;
        }
        return val.value;
    },
    val: (val, key) => {
        if (!val || !val[key]) {
            return;
        }
        return val[key];
    },
    isArr:(val) =>{
        if(typeof val == 'string'){
            return val
        }else{
            return val[0]
        }
    },
    map: (val) => {
        if (!val || !mapJson[val]) {
            return '';
        }
        return mapJson[val].name;
    },
    addr: (val, p, c, co) => {
        if (!val) {
            return '';
        }
        let res = val.replace(new RegExp(mapJson[p].name + mapJson[c].name + mapJson[co].name, 'g'), '');
        return res;
    },
    lately: (v) => {
        /* let hour = parseInt(moment( new Date() ).diff(moment(v)) / 3600000); */
        let today = moment(new Date()).format('YYYY-MM-DD') === moment(v).format('YYYY-MM-DD');
        let res;
        if (!today) {
            res = moment(v).fromNow();
        } else {
            res = moment(v).format('HH:mm');
        }
        return res;
    },
    //今日工作-接诊台 显示当前等待时间
    showWaitTime:(value) => {
        let res= Math.floor(((new Date())-(new Date(value)))/60000)<0?"0":Math.floor(((new Date())-(new Date(value)))/60000)
        return res;
    },
    //金额千分位
    formatCurrency(num,isshow) {
        num !== undefined || (num = '0.00') ;
        num = num.toString().replace(/\$|\,/g, '');
	 // 检查传入数值为数值类型
	 	if (isNaN(num))
	  	num = "0";
	 // 获取符号(正/负数)
	 	var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num * Math.pow(10, 2) + 0.50000000001); // 把指定的小数位先转换成整数.多余的小数位四舍五入
	 	var cents = num % Math.pow(10, 2); // 求出小数位数值
	 	num = Math.floor(num / Math.pow(10, 2)).toString(); // 求出整数位数值
	 	cents = cents.toString(); // 把小数位转换成字符串,以便求小数位长度

	 // 补足小数位到指定的位数
	 	while (cents.length < 2)
	  	cents = "0" + cents;

	  // 对整数部分进行千分位格式化.
	  	for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++){
           num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
        }

        if(isshow === false){
            if(parseFloat(num)==0 && parseFloat(cents)==0){
                return '';
            }else{
                return (((sign) ? '' : '-') + num + '.' + cents);
            }
        }else{
            return (((sign) ? '' : '-') + num + '.' + cents);
        }

	},
	//时间戳转化成日期
	transTime: (date,value='YYYY-MM-DD') => {
        if (!date) {
            return '';
        }
        let val;
        val = moment(new Date(date*1000)).format(value);
        return val;
    },
    //	时间格式化   (YYYY-MM-DD HH:mm)
	changeTime(time){
		let time1 = moment(time).format('YYYY-MM-DD  HH:mm');
		return time1;
    },
    changeTimeToData(time){
		let time1 = moment(time).format('YYYY-MM-DD');
		return time1;
	}
}
export default filter;



// WEBPACK FOOTER //
// ./src/config/filtes.js